import script from "./DepartureData.vue?vue&type=script&setup=true&lang=js"
export * from "./DepartureData.vue?vue&type=script&setup=true&lang=js"

import "./DepartureData.vue?vue&type=style&index=0&id=327846d6&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-327846d6"]])

export default __exports__